import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuitemComponent } from '../menuitem/menuitem.component';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-menu',
  imports: [CommonModule, MenuitemComponent, RouterModule],
  templateUrl: './menu.component.html',
})
export class MenuComponent {
  @Input()
  model: MenuItem[] = [];


}
